import type { GetStyles, OpacityStyledProps } from '@sds-system/types';

export const getOpacityStyles: GetStyles<OpacityStyledProps> = ({ opacity, theme }) => {
  if (opacity) {
    return {
      opacity: theme.opacity[opacity],
    };
  }
  return {};
};
